
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/resize-photo-kb",
      function () {
        return require("private-next-pages/resize-photo-kb/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/resize-photo-kb"])
      });
    }
  